import { render, staticRenderFns } from "./CaseDashboard.vue?vue&type=template&id=28eb1f1f&lang=pug"
import script from "./CaseDashboard.vue?vue&type=script&lang=js"
export * from "./CaseDashboard.vue?vue&type=script&lang=js"
import style0 from "./CaseDashboard.vue?vue&type=style&index=0&id=28eb1f1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports